// component
import SvgColor from "../../components/svgColor/index";
import DashBoardIcon from "../../assets/images/DashBoardIcon.svg";
import ShieldIcon from "../../assets/images/ShieldIcon.svg";
import CalculatorIcon from "../../assets/images/CalculatorIcon.svg";
import LenceIcon from "../../assets/images/LenceIcon.svg";
import PersonIcon from "../../assets/images/personIcon.svg";
import DucousersIcon from "../../assets/images/DucousersIcon.svg";
import helpIcon from "../../assets/images/helpIcon.svg";
import mailIcon from "../../assets/images/mailIcon.svg";
// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={name} sx={{ width: 20, height: 20 }} />;

const navConfig = [
  {
    title: "Dashboard",
    path: "/Dashboard/Home",
    icon: icon(DashBoardIcon),
  },
  {
    title: "Plan details",
    path: "/Dashboard/planDetails",
    icon: icon(ShieldIcon),
  },
  {
    title: "Members",
    path: "/Dashboard/users",
    icon: icon(PersonIcon),
  },
  {
    title: "Support Requests",
    path: "/Dashboard/support",
    icon: icon(helpIcon),
  },
  {
    title: "Daily Transactions",
    path: "/Dashboard/dailyTransactions",
    icon: icon(mailIcon),
  },
  {
    title: "Calculation details",
    path: "/Dashboard/calcDetails",
    icon: icon(CalculatorIcon),
  },
  {
    title: "Latest plan details",
    path: "/Dashboard/blog",
    icon: icon(LenceIcon),
  },
];

export default navConfig;
